import { Line, Vector } from '../../models';

/**
 * Create a new line layout, which is a line between two points.
 */
export function newLine(startPoint: Vector, endPoint: Vector): Line {
  return {
    start: startPoint,
    end: endPoint,
    type: 'LINE',
  };
}
